

// export const NavbarData = [
    
//     {
//         id: 1,
//         navText: "Features",
//         navUrl: "Features",
//         navLink: "nav-link"
//     },
//     {
//         id: 2,
//         navText: "About",
//         navUrl: "About",
//         navLink: "nav-link",
//         navigate:'navigate('/')'
//     },
//     {
//         id: 3,
//         navText: "Blog",
//         navUrl: "Blog",
//         navLink: "nav-link",
//         navigate: 'navigate('/')'
//     },
//     {
//         id: 4,
//         navText: "FAQs",
//         navUrl: "FAQs",
//         navLink: "nav-link",
//         cName: "faqs",
//         navigate: 'navigate(' / ')'
//     },
//     {
//         id: 5,
//         navText: "Contacts",
//         navUrl: "#",
//         navLink: "nav-link",
//         cName: "contact",
       
//     },
//     {
//         id: 6,
//         navText: "I have an account. Log in",
//         navUrl: "#",
//         navLink: "nav-link",
//         cName: "login",
//         navigate: 'navigate(' / ')'
//     },
//     {
//         id: 7,
//         navText: "Create an account",
//         navUrl: "#",
//         navLink: "nav-link",
//         cName: "register",
//         navigate: 'navigate(' / ')'
//     }
// ];

export const HeroMain = [
    {
        id: 1,
        heroheader: "Trade Gift Cards & Crypto",
        herotitle: "5x Faster",
        herocontent:
            "Hannah is  that one platform to buy & sell all kinds of Gift cards and Cryptocurrencies in less than 5 mins.",
        heroImg: '/assets/iPhone 14 Pro.svg',
        heroAndroid: "Android",
        heroIconA: '/assets/GooglePlayLogo.svg',
        heroIos: "Ios",
        heroIconI: "/assets/AppStoreLogo.svg",
        heroWeb: "Web",
        heroIconW: "/assets/GlobeSimple.svg",
        cName: 'Icons',
        iconLink: "#Download",
        cNameImg: 'iphone-icon'
    }
];

export const solutionIcon = [
    {
        id: 1,
        cardIcon: '/assets/Steam-ebay.svg',
        alt: 'steam-ebay',
        cName: 'cardIcon'
    },
    {
        id: 2,
        cardIcon: '/assets/bitcoin-van-seph.svg',
        alt: 'bitcoin-van-seph',
        cName: 'cardIcon'
    },
    {
        id: 3,
        cardIcon: '/assets/Nord-razor-nike.svg',
        alt: 'Nord-razor-nike',
        cName: 'cardIcon-nord'
    },
    {
        id: 4,
        cardIcon: '/assets/Itunes-google.svg',
        alt: 'Itunes-google',
        cName: 'cardIcon'
    },
    {
        id: 5,
        cardIcon: '/assets/American-wal-mac.svg',
        alt: 'American-wal-mac',
        cName: 'cardIcon'
    },
    {
        id: 6,
        cardIcon: '/assets/American-t.svg',
        alt: 'American-t',
        cName: 'cardIcon'
    }
    
]

export const solutionContent = [
    {
        textheader: 'Trading solution that works for you.',
        textcontent: 'Hannah meets you where you are – and takes you where you want to go.'
    }
]
export const solutionNewsIcon = [
    {
        id: 1,
        newsIcon: '/assets/Punch.svg',
        alt: 'punch icon',
        cName: 'newsIcon'
    },
    {
        id: 2,
        newsIcon: '/assets/Trinune.svg',
        alt: 'Trinune icon',
        cName: 'newsIcon'
    },
    {
        id: 3,
        newsIcon: '/assets/Legit NG.svg',
        alt: 'Legit icon',
        cName: 'newsIcon'
    },
    {
        id: 4,
        newsIcon: '/assets/Premium Times.svg',
        alt: 'Premium Times icon',
        cName: 'newsIcon'
    },
    {
        id: 5,
        newsIcon: '/assets/Techcabal.svg',
        alt: 'Techcabal icon',
        cName: 'newsIcon'
    }
]
export const ConvertDataHeader = [
    {
        id: 1,
        texttitle: 'Get started with Hannah.',
        textcontent: 'Hannah allows you to convert your gift cards & crypto to cash instantly.',

    },
]
export const ConvertDataMain = [
   
    {
        id: 1,
        box1img1:'/assets/Toast.svg',
        cName1: 'Toast',
        box1img2:'/assets/naira-icon-right.svg',
        cName2: 'naira-right',
        box1img3: '/assets/Wallet.svg',
        cName3: 'Wallet',
        box1img4:'/assets/naira-icon-left.svg',
        cName4: 'naira-left',
        box1title:'No Waiting, Get Paid Instantly.',
        box1content: 'No more waiting for long hours to get paid. Hannah has partnered with the fastest payment processors with instant payout.',
        box2img1: '/assets/hand-bitcoin.svg',
        alt: 'hand-bitcoin hhh',
        box2title: 'Be In Complete Control',
        box2content: 'Buy & sell gift cards, deposit and trade crypto, pay bills and move your money freely however you like with our virtual bank account.',
         buttonjjj: 'Get started',
        arrow: '/assets/arrow-left.svg',
        cNameArrow: 'arrow-left',
        cNameBtn: 'gettingStarted-btn',
        cNameHand: 'handIcon'

    }

]
